<template>
  <div class="home">
    <div class="row">
      <div class="col-md-12">
        <!--begin::Portlet-->
        <div class="m-portlet">
          <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
              <div class="m-portlet__head-title">
                <span class="m-portlet__head-icon m--hide">
                  <i class="la la-gear"></i>
                </span>
                <h3 class="m-portlet__head-text">Exam</h3>
              </div>
            </div>
          </div>
          <div class="m-portlet__body">
            <div class="row">
              <div class="col-md-12">
                <div class="exam-content">
                  <div class="m-portlet m-portlet--tabs">
                    <div class="m-portlet__head">
                      <div class="m-portlet__head-tools">
                        <ul class="nav nav-tabs m-tabs-line m-tabs-line--primary m-tabs-line--2x" role="tablist">
                          <li class="nav-item m-tabs__item">
                            <a class="nav-link m-tabs__link active show" data-toggle="tab" href="#m_tabs_6_1" role="tab" aria-selected="true">
                              My Exam
                            </a>
                          </li>
                          <li class="nav-item m-tabs__item">
                            <a class="nav-link m-tabs__link" data-toggle="tab" href="#m_tabs_6_2" role="tab" aria-selected="false">
                              Browse Exam
                            </a>
                          </li>
                          <li class="nav-item m-tabs__item">
                            <a class="nav-link m-tabs__link" data-toggle="tab" href="#m_tabs_6_3" role="tab" aria-selected="false">
                              Payment History
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="m-portlet__body">
                      <div class="tab-content">
                        <div class="tab-pane active show" id="m_tabs_6_1" role="tabpanel">
                          <div class="row payment mobile-m-t-20">
                            <div class="col-md-9">
                              <div class="inner-content">
                                <a href="#exam_lists">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <div class="top-card sheduled">
                                        <div class="img-top">
                                          <div class="circle">
                                            <img src="images/shdeule.png" />
                                          </div>
                                        </div>
                                        <div class="right-top">
                                          <h3>Schedule Exams</h3>
                                          <div class="type-exam">
                                            <div class="btn-group" role="group" aria-label="Basic example">
                                              <button type="button" class="btn btn-secondary">{{studentOnlineScheduledExam.length}} Online</button>
                                              <button type="button" class="btn btn-secondary">{{studentOfflinePendingExam.length}} Offline</button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-4">
                                      <div class="top-card completed">
                                        <div class="img-top">
                                          <div class="circle">
                                            <img src="images/completed.png" />
                                          </div>
                                        </div>
                                        <div class="right-top">
                                          <h3>Completed Exams</h3>
                                          <div class="type-exam">
                                            <div class="btn-group" role="group" aria-label="Basic example">
                                              <button type="button" class="btn btn-secondary">{{studentOnlineCompletedExam.length}} Online</button>
                                              <button type="button" class="btn btn-secondary">{{studentOfflineCompletedExam.length}} Offline</button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-4">
                                      <div class="top-card not-attend">
                                        <div class="img-top">
                                          <div class="circle">
                                            <img src="images/not-attend.png" />
                                          </div>
                                        </div>
                                        <div class="right-top">
                                          <h3>Not Attend</h3>
                                          <div class="type-exam">
                                            <div class="btn-group" role="group" aria-label="Basic example">
                                              <button type="button" class="btn btn-secondary">{{studentOnlineNotAttendedExam.length}} Online</button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </a>
                              </div>
                              <div class="inner-content"  id="exam_lists">
                                <div class="row">
                                    <div class="col-md-12">
                                      <div class="exam-content">
                                        <div class="m-portlet m-portlet--tabs" style="background-color: #f9fafc;">
                                          <div class="m-portlet__head">
                                            <div class="m-portlet__head-caption">
                                              <div class="m-portlet__head-title">
                                                <h3 class="m-portlet__head-text">
                                                  Online Exams
                                                </h3>
                                              </div>
                                            </div>
                                            <div class="m-portlet__head-tools">
                                              <ul class="nav pull-right nav-tabs m-tabs-line m-tabs-line--primary m-tabs-line--2x" role="tablist">
                                                <li class="nav-item m-tabs__item">
                                                  <a class="nav-link m-tabs__link active show" data-toggle="tab" href="#online_pending_approval_tab" role="tab" aria-selected="true">
                                                    Pending Approval
                                                  </a>
                                                </li>
                                                <li class="nav-item m-tabs__item">
                                                  <a class="nav-link m-tabs__link" data-toggle="tab" href="#online_scheduled_tab" role="tab" aria-selected="true">
                                                    Schedule
                                                  </a>
                                                </li>
                                                <li class="nav-item m-tabs__item">
                                                  <a class="nav-link m-tabs__link" data-toggle="tab" href="#online_completed_tab" role="tab" aria-selected="false">
                                                    Completed
                                                  </a>
                                                </li>
                                                <li class="nav-item m-tabs__item">
                                                  <a class="nav-link m-tabs__link" data-toggle="tab" href="#online_not_attend_tab" role="tab" aria-selected="false">
                                                      Not Attend
                                                  </a>
                                                </li>
                                              </ul>
                                            </div>
                                          </div>
                                          <div class="m-portlet__body">
                                            <div class="tab-content">
                                              <div class="tab-pane active show" id="online_pending_approval_tab" role="tabpanel">
                                                <div v-if="studentOnlinePendingApprovalExam.length > 0" class="m-accordion m-accordion--default m-accordion--solid m-accordion--section m-accordion--toggle-arrow" id="m_accordion_1" role="tablist">
                                                  <!--begin::Item-->
                                                  <div v-for="(exam, index) in studentOnlinePendingApprovalExam" :key="index" class="m-accordion__item">
                                                    <div class="m-accordion__item-head tooltiptext_block" role="tab" :id="'m_accordion_1_item_'+index+'_head'" data-toggle="collapse" :href="'#m_accordion_1_item_'+index+'_body'" aria-expanded="true">
                                                      <span class="m-accordion__item-icon ex-code"><p>Exam code</p>{{exam.exam_master.exam_code}}</span>
                                                      <span class="m-accordion__item-title ex-name">
                                                        <p>{{exam.exam_master.exam_name}}</p>
                                                        <span class="days start"><strong>Start:</strong> {{exam.exam_master.start_date}}</span>
                                                        <span class="days end"><strong>End:</strong> {{exam.exam_master.end_date}}</span>
                                                      </span>
                                                      <div class="other-option">
                                                        <span class="badge badge-pill badge-light due right-to">{{(exam.exam_master.duration > 0)? exam.exam_master.duration + ' Minutes': 'No fixed duration'}}</span>
                                                      </div>
                                                      <span class="tooltiptext">Click to Expand</span>
                                                    </div>
                                                    <div class="m-accordion__item-body collapse" :id="'m_accordion_1_item_'+index+'_body'" role="tabpanel" :aria-labelledby="'m_accordion_1_item_'+index+'_head'" data-parent="#m_accordion_1">
                                                      <div class="m-accordion__item-content">
                                                        <div class="row">
                                                          <div class="col-md-8">
                                                            <div class="left-exam">
                                                                <p>{{exam.exam_master.exam_note}}</p>
                                                            </div>
                                                          </div>
                                                          <div class="col-md-4"></div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <!--end::Item-->
                                                </div>
                                                <div v-else>
                                                    <div class="empty-data">
                                                      <img src="/media/icons/empty.png" />
                                                      <h2>No Pending Approval Exams Available</h2>
                                                    </div>
                                                </div>
                                              </div>
                                              <div class="tab-pane" id="online_scheduled_tab" role="tabpanel">
                                                <div v-if="studentOnlineScheduledExam.length > 0" class="m-accordion m-accordion--default m-accordion--solid m-accordion--section m-accordion--toggle-arrow" id="m_accordion_1" role="tablist">
                                                  <!--begin::Item-->
                                                  <div v-for="(exam, index) in studentOnlineScheduledExam" :key="index" class="m-accordion__item">
                                                    <div class="m-accordion__item-head tooltiptext_block" role="tab" :id="'m_accordion_1_item_'+index+'_head'" data-toggle="collapse" :href="'#m_accordion_1_item_'+index+'_body'" aria-expanded="true">
                                                      <span class="m-accordion__item-icon ex-code"><p>Exam code</p>{{exam.exam_master.exam_code}}</span>
                                                      <span class="m-accordion__item-title ex-name">
                                                        <p>{{exam.exam_master.exam_name}}</p>
                                                        <span class="days start"><strong>Start:</strong> {{exam.exam_master.start_date}}</span>
                                                        <span class="days end"><strong>End:</strong> {{exam.exam_master.end_date}}</span>
                                                      </span>
                                                      <div class="other-option">
                                                        <span class="badge badge-pill badge-light due">{{(exam.exam_master.duration > 0)? exam.exam_master.duration + ' Minutes': 'No fixed duration'}}</span>
                                                        <a @click.prevent="setExamData(exam.id, exam.exam_master.exam_name)" v-if="exam.attendence_status == 'assigned'" class="btn btn-primary exam-list" href="#" role="button" data-toggle="modal" data-target="#start-exam-modal">Start Exam</a>
                                                        <a @click.prevent="setExamData(exam.id, exam.exam_master.exam_name)" v-if="exam.attendence_status == 'started'" v-on:click="showModal = true" class="btn btn-primary exam-list continue" href="#" role="button" data-toggle="modal" data-target="#continue-exam-modal">Continue Exam</a>
                                                      </div>
                                                      <span class="tooltiptext">Click to Expand</span>
                                                      <!-- <div class="dropdown">
                                                        <img src="images/dots.png" width="14" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" />
                                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">sss</div>
                                                      </div> -->
                                                    </div>
                                                    <div class="m-accordion__item-body collapse" :id="'m_accordion_1_item_'+index+'_body'" role="tabpanel" :aria-labelledby="'m_accordion_1_item_'+index+'_head'" data-parent="#m_accordion_1">
                                                      <div class="m-accordion__item-content">
                                                        <div class="row">
                                                          <div class="col-md-8">
                                                            <div class="left-exam">
                                                              <div class="download-row">
                                                                <div class="download-item">
                                                                  <a v-if="exam.exam_master.upload_question_paper != ''" :href="examDocumentURL+exam.exam_master.upload_question_paper">
                                                                    <img src="images/pdf.png" /> Download Question Paper
                                                                  </a>
                                                                </div>
                                                                <div class="download-item">
                                                                  <a v-if="exam.exam_master.upload_marking_scheme != ''" :href="examDocumentURL+exam.exam_master.upload_marking_scheme">
                                                                    <img src="images/pdf.png" /> Download  Answer Sheet
                                                                  </a>
                                                                </div>
                                                              </div>
                                                                <p>{{exam.exam_master.exam_note}}</p>
                                                            </div>
                                                          </div>
                                                          <div class="col-md-4"></div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <!--end::Item-->
                                                </div>
                                                <div v-else>
                                                    <div class="empty-data">
                                                      <img src="/media/icons/empty.png" />
                                                      <h2>No Scheduled Exams Available</h2>
                                                    </div>
                                                </div>
                                              </div>
                                              <div class="tab-pane" id="online_completed_tab" role="tabpanel">
                                                <div v-if="studentOnlineCompletedExam.length > 0" class="m-accordion m-accordion--default m-accordion--solid m-accordion--section m-accordion--toggle-arrow" id="m_accordion_2" role="tablist">
                                                  <!--begin::Item-->
                                                  <div v-for="(exam, index) in studentOnlineCompletedExam" :key="index" class="m-accordion__item">
                                                    <div class="m-accordion__item-head tooltiptext_block" role="tab" :id="'m_accordion_2_item_'+index+'_head'" data-toggle="collapse" :href="'#m_accordion_2_item_'+index+'_body'" aria-expanded="true">
                                                      <span class="m-accordion__item-icon ex-code"><p>Exam code</p>{{exam.exam_master.exam_code}}</span>
                                                      <span class="m-accordion__item-title ex-name">
                                                        <p>{{exam.exam_master.exam_name}}</p>
                                                        <span class="days start"><strong>Start:</strong> {{exam.exam_master.start_date}}</span>
                                                        <span class="days end"><strong>End:</strong> {{exam.exam_master.end_date}}</span>
                                                      </span>
                                                      <div class="other-option">
                                                        <a class="btn btn-primary exam-list" href="#" role="button" @click.prevent="reviewExam(exam.id)">Review Exam</a>
                                                        <span class="badge badge-pill badge-light due right-to">{{(exam.exam_master.duration > 0)? exam.exam_master.duration + ' Minutes': 'No fixed duration'}}</span>
                                                      </div>
                                                      <span class="tooltiptext">Click to Expand</span>
                                                      <!-- <div class="dropdown">
                                                        <img src="images/dots.png" width="14" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" />
                                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">sss</div>
                                                      </div> -->
                                                    </div>
                                                    <div class="m-accordion__item-body collapse" :id="'m_accordion_2_item_'+index+'_body'" role="tabpanel" :aria-labelledby="'m_accordion_2_item_'+index+'_head'" data-parent="#m_accordion_2">
                                                      <div class="m-accordion__item-content">
                                                        <div class="row">
                                                          <div class="col-md-8">
                                                            <div class="left-exam">
                                                              <div class="download-row">
                                                                <div class="download-item">
                                                                  <a v-if="exam.exam_master.upload_question_paper != ''" :href="examDocumentURL+exam.exam_master.upload_question_paper">
                                                                    <img src="images/pdf.png" /> Download Question Paper
                                                                  </a>
                                                                </div>
                                                                <div class="download-item">
                                                                  <a v-if="exam.exam_master.upload_marking_scheme != ''" :href="examDocumentURL+exam.exam_master.upload_marking_scheme">
                                                                    <img src="images/pdf.png" /> Download  Answer Sheet
                                                                  </a>
                                                                </div>
                                                              </div>
                                                                <p>{{exam.exam_master.exam_note}}</p>
                                                            </div>
                                                          </div>
                                                          <div class="col-md-4"></div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <!--end::Item-->
                                                </div>
                                                <div v-else>
                                                    <div class="empty-data">
                                                      <img src="/media/icons/empty.png" />
                                                      <h2>No Completed Exams Available</h2>
                                                    </div>
                                                </div>
                                              </div>
                                              <div class="tab-pane" id="online_not_attend_tab" role="tabpanel">
                                                <div v-if="studentOnlineNotAttendedExam.length > 0" class="m-accordion m-accordion--default m-accordion--solid m-accordion--section m-accordion--toggle-arrow" id="m_accordion_3" role="tablist">
                                                  <!--begin::Item-->
                                                  <div v-for="(exam, index) in studentOnlineNotAttendedExam" :key="index" class="m-accordion__item">
                                                    <div class="m-accordion__item-head tooltiptext_block" role="tab" :id="'m_accordion_3_item_'+index+'_head'" data-toggle="collapse" :href="'#m_accordion_3_item_'+index+'_body'" aria-expanded="true">
                                                      <span class="m-accordion__item-icon ex-code"><p>Exam code</p>{{exam.exam_master.exam_code}}</span>
                                                      <span class="m-accordion__item-title ex-name">
                                                        <p>{{exam.exam_master.exam_name}}</p>
                                                        <span class="days start"><strong>Start:</strong> {{exam.exam_master.start_date}}</span>
                                                        <span class="days end"><strong>End:</strong> {{exam.exam_master.end_date}}</span>
                                                      </span>
                                                      <div class="other-option">
                                                        <span class="badge badge-pill badge-light due right-to">{{(exam.exam_master.duration > 0)? exam.exam_master.duration + ' Minutes': 'No fixed duration'}}</span>
                                                        <!-- <a class="btn btn-primary exam-list" href="#" role="button" data-toggle="modal" data-target="#start-exam-modal">Reattend Exam</a>                                                                   -->
                                                      </div>
                                                      <span class="tooltiptext">Click to Expand</span>
                                                      <!-- <div class="dropdown">
                                                        <img src="images/dots.png" width="14" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" />
                                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">sss</div>
                                                      </div> -->
                                                    </div>
                                                    <div class="m-accordion__item-body collapse" :id="'m_accordion_3_item_'+index+'_body'" role="tabpanel" :aria-labelledby="'m_accordion_3_item_'+index+'_head'" data-parent="#m_accordion_3">
                                                      <div class="m-accordion__item-content">
                                                        <div class="row">
                                                          <div class="col-md-8">
                                                            <div class="left-exam">
                                                              <div class="download-row">
                                                                <div class="download-item">
                                                                  <a v-if="exam.exam_master.upload_question_paper != ''" :href="examDocumentURL+exam.exam_master.upload_question_paper">
                                                                    <img src="images/pdf.png" /> Download Question Paper
                                                                  </a>
                                                                </div>
                                                                <div class="download-item">
                                                                  <a v-if="exam.exam_master.upload_marking_scheme != ''" :href="examDocumentURL+exam.exam_master.upload_marking_scheme">
                                                                    <img src="images/pdf.png" /> Download  Answer Sheet
                                                                  </a>
                                                                </div>
                                                              </div>
                                                                <p>{{exam.exam_master.exam_note}}</p>
                                                            </div>
                                                          </div>
                                                          <div class="col-md-4"></div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <!--end::Item-->
                                                </div>
                                                <div v-else>
                                                    <div class="empty-data">
                                                      <img src="/media/icons/empty.png" />
                                                      <h2>No Attendant Exams Available</h2>
                                                    </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                              </div>
                              <div class="inner-content">
                                <div class="row">
                                    <div class="col-md-12">
                                      <div class="exam-content">
                                        <div class="m-portlet m-portlet--tabs" style="background-color: #f9fafc;">
                                          <div class="m-portlet__head">
                                            <div class="m-portlet__head-caption">
                                              <div class="m-portlet__head-title">
                                                <h3 class="m-portlet__head-text">
                                                  Offline Exams
                                                </h3>
                                              </div>
                                            </div>
                                            <div class="m-portlet__head-tools">
                                              <ul class="nav pull-right nav-tabs m-tabs-line m-tabs-line--primary m-tabs-line--2x" role="tablist">
                                                <li class="nav-item m-tabs__item">
                                                  <a class="nav-link m-tabs__link active show" data-toggle="tab" href="#offline_pending_tab" role="tab" aria-selected="true">
                                                    Pending
                                                  </a>
                                                </li>
                                                <li class="nav-item m-tabs__item">
                                                  <a class="nav-link m-tabs__link" data-toggle="tab" href="#offline_completed_tab" role="tab" aria-selected="false">
                                                    Completed
                                                  </a>
                                                </li>
                                              </ul>
                                            </div>
                                          </div>
                                          <div class="m-portlet__body">
                                            <div class="tab-content">
                                              <div class="tab-pane active show" id="offline_pending_tab" role="tabpanel">
                                                <div v-if="studentOfflinePendingExam.length > 0" class="m-accordion m-accordion--default m-accordion--solid m-accordion--section m-accordion--toggle-arrow" id="m_accordion_4" role="tablist">
                                                  <!--begin::Item-->
                                                  <div v-for="(exam, index) in studentOfflinePendingExam" :key="index" class="m-accordion__item">
                                                    <div class="m-accordion__item-head tooltiptext_block" role="tab" :id="'m_accordion_4_item_'+index+'_head'" data-toggle="collapse" :href="'#m_accordion_4_item_'+index+'_body'" aria-expanded="true">
                                                      <span class="m-accordion__item-icon ex-code"><p>Exam code</p>{{exam.exam_master.exam_code}}</span>
                                                      <span class="m-accordion__item-title ex-name">
                                                        <p>{{exam.exam_master.exam_name}}</p>
                                                        <span class="days start"><strong>Start:</strong> {{exam.exam_master.start_date}}</span>
                                                        <span class="days end"><strong>End:</strong> {{exam.exam_master.end_date}}</span>
                                                      </span>
                                                      <div class="other-option">
                                                        <span class="badge badge-pill badge-light due">{{(exam.exam_master.duration > 0)? exam.exam_master.duration + ' Minutes': 'No fixed duration'}}</span>
                                                        <a @click="openCompleteOfflineExamModal(exam.id, exam.exam_master.exam_name)" class="btn btn-primary exam-list" href="#" role="button" data-toggle="modal" data-target="#complete-offline-exam-modal">Mark as Complete</a>
                                                      </div>
                                                      <span class="tooltiptext">Click to Expand</span>
                                                      <!-- <div class="dropdown">
                                                        <img src="images/dots.png" width="14" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" />
                                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">sss</div>
                                                      </div> -->
                                                    </div>
                                                    <div class="m-accordion__item-body collapse" :id="'m_accordion_4_item_'+index+'_body'" role="tabpanel" :aria-labelledby="'m_accordion_4_item_'+index+'_head'" data-parent="#m_accordion_4">
                                                      <div class="m-accordion__item-content">
                                                        <div class="row">
                                                          <div class="col-md-8">
                                                            <div class="left-exam">
                                                              <div class="download-row">
                                                                <div class="download-item">
                                                                  <a v-if="exam.exam_master.upload_question_paper != ''" :href="examDocumentURL+exam.exam_master.upload_question_paper">
                                                                    <img src="images/pdf.png" /> Download Question Paper
                                                                  </a>
                                                                </div>
                                                                <div class="download-item">
                                                                  <a v-if="exam.exam_master.upload_marking_scheme != ''" :href="examDocumentURL+exam.exam_master.upload_marking_scheme">
                                                                    <img src="images/pdf.png" /> Download  Answer Sheet
                                                                  </a>
                                                                </div>
                                                              </div>
                                                                <p>{{exam.exam_master.exam_note}}</p>
                                                            </div>
                                                          </div>
                                                          <div class="col-md-4"></div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <!--end::Item-->
                                                </div>
                                                <div v-else>
                                                    <div class="empty-data">
                                                      <img src="/media/icons/empty.png" />
                                                      <h2>No Pending Exams Available</h2>
                                                    </div>
                                                </div>
                                              </div>
                                              <div class="tab-pane" id="offline_completed_tab" role="tabpanel">
                                                <div v-if="studentOfflineCompletedExam.length > 0" class="m-accordion m-accordion--default m-accordion--solid m-accordion--section m-accordion--toggle-arrow" id="m_accordion_5" role="tablist">
                                                  <!--begin::Item-->
                                                  <div v-for="(exam, index) in studentOfflineCompletedExam" :key="index" class="m-accordion__item">
                                                    <div class="m-accordion__item-head tooltiptext_block" role="tab" :id="'m_accordion_5_item_'+index+'_head'" data-toggle="collapse" :href="'#m_accordion_5_item_'+index+'_body'" aria-expanded="true">
                                                      <span class="m-accordion__item-icon ex-code"><p>Exam code</p>{{exam.exam_master.exam_code}}</span>
                                                      <span class="m-accordion__item-title ex-name">
                                                        <p>{{exam.exam_master.exam_name}}</p>
                                                        <span class="days start"><strong>Start:</strong> {{exam.exam_master.start_date}}</span>
                                                        <span class="days end"><strong>End:</strong> {{exam.exam_master.end_date}}</span>
                                                      </span>
                                                      <div class="other-option">
                                                        <span class="badge badge-pill badge-light due right-to">{{(exam.exam_master.duration > 0)? exam.exam_master.duration + ' Minutes': 'No fixed duration'}}</span>
                                                      </div>
                                                      <span class="tooltiptext">Click to Expand</span>
                                                      <!-- <div class="dropdown">
                                                        <img src="images/dots.png" width="14" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" />
                                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">sss</div>
                                                      </div> -->
                                                    </div>
                                                    <div class="m-accordion__item-body collapse" :id="'m_accordion_5_item_'+index+'_body'" role="tabpanel" :aria-labelledby="'m_accordion_5_item_'+index+'_head'" data-parent="#m_accordion_5">
                                                      <div class="m-accordion__item-content">
                                                        <div class="row">
                                                          <div class="col-md-8">
                                                            <div class="left-exam">
                                                              <div class="download-row">
                                                                <div class="download-item">
                                                                  <a v-if="exam.exam_master.upload_question_paper != ''" :href="examDocumentURL+exam.exam_master.upload_question_paper">
                                                                    <img src="images/pdf.png" /> Download Question Paper
                                                                  </a>
                                                                </div>
                                                                <div class="download-item">
                                                                  <a v-if="exam.exam_master.upload_marking_scheme != ''" :href="examDocumentURL+exam.exam_master.upload_marking_scheme">
                                                                    <img src="images/pdf.png" /> Download  Answer Sheet
                                                                  </a>
                                                                </div>
                                                              </div>
                                                                <p>{{exam.exam_master.exam_note}}</p>
                                                            </div>
                                                          </div>
                                                          <div class="col-md-4"></div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <!--end::Item-->
                                                </div>
                                                <div v-else>
                                                    <div class="empty-data">
                                                      <img src="/media/icons/empty.png" />
                                                      <h2>No Completed Exams Available</h2>
                                                    </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="shedule">
                                <h2>Next Exam Scheduled <br> <small style="color: #ff8d05;">(Starting from today)</small> </h2> <br>
                                <img src="images/clock.png" />
                                <div class="btn-group" role="group" aria-label="Basic example">
                                  <vue-countdown :time="nextExamDuration" v-slot="{ days, hours, minutes, seconds }">
                                    <button type="button" class="btn btn-secondary">
                                      {{days}}
                                      <span>Days</span>
                                    </button>
                                    <button type="button" class="btn btn-secondary">
                                      {{hours}}
                                      <span>Hours</span>
                                    </button>
                                    <button type="button" class="btn btn-secondary">
                                      {{minutes}}
                                      <span>Mins</span>
                                    </button>
                                    <button type="button" class="btn btn-secondary">
                                      {{seconds}}
                                      <span>Secs</span>
                                    </button>
                                  </vue-countdown>
                                </div>
                              </div>
                              <div class="result-area">
                                  <h2>Past Exam Results</h2>
                                  <img src="images/result.png" />

                                  <div v-for="(exams, examIndex) in studentExamData" :key="examIndex" class="result-row">
                                    <span class="result-name">{{exams.exam_master ? exams.exam_master.exam_name : '' }}</span>
                                    <div class="result-line">
                                      <div class="progress">
                                        <div class="progress-bar" :class="(exams.studentTotalMarks > (exams.exam_master ? exams.exam_master.passing_percentage : 0))? 'bg-success': 'bg-danger'" role="progressbar" :style="'width: ' + exams.studentTotalMarks + '%'" :aria-valuenow="exams.studentTotalMarks" aria-valuemin="0" :aria-valuemax="exams.examTotalMarks"></div>
                                      </div>
                                    <span class="result-count float-left">({{exams.studentTotalMarks}}/{{exams.examTotalMarks}})</span>
                                    <span class="result-count"><small>Passing Mark:<strong>{{exams.exam_master ? exams.exam_master.passing_percentage : 0}}</strong></small></span>
                                    </div>
                                  </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="tab-pane" id="m_tabs_6_2" role="tabpanel">
                          <div class="row payment mobile-m-t-20">
                            <div class="col-md-12">
                              <div class="search-section">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <div class="form-group">
                                        <select @change="getFilterOptionData('courses')" name="courses" required id="courses" class="form-control" style="width:100%">
                                          <option value="" >All Course</option>
                                          <option v-for="course in courseList" :key="course.id" :value="course.id">{{course.name}}</option>
                                        </select>
                                      </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                          <select @change="getFilterOptionData('subjects')" name="subjects" required id="subjects" class="form-control" style="width:100%">
                                            <option value="" v-if="subjectList.length > 0">All Subject</option>
                                            <option value="" v-else>No Subjects</option>
                                            <option v-for="subject in subjectList" :key="subject.id" :value="subject.id" >{{subject.name}}</option>
                                          </select>
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                          <select name="exams" required id="exams" class="form-control" style="width:100%">
                                            <option value="" v-if="examsList.length > 0">Select Exam</option>
                                            <option value="" v-else >No Exams</option>
                                            <option v-for="exam in examsList" :key="exam.id" :value="exam.id" >{{exam.exam_name}}</option>
                                          </select>
                                        </div>
                                    </div>
                                     <div class="col-md-1">
                                        <div class="form-group">
                                          <input type="text" name="academic_year" id="academic_year" class="form-control" placeholder="Year" />
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                      <button @click="searchExam()" type="submit" class="btn btn-primary btn-info" :disabled="(examsList.length > 0)? false: true">Search Now</button>
                                    </div>
                                  </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" v-if="loaderlist">
                            <div class="col-md-3 col-lg-3 col-xl-3 course-card">
                              <div class="modern-card loading-box">
                                Data loading...
                                <facebook-loader></facebook-loader>
                              </div>
                            </div>
                            <div class="col-md-3 col-lg-3 col-xl-3 course-card mobile-hide">
                              <div class="modern-card loading-box">
                                Data loading...
                                <facebook-loader></facebook-loader>
                              </div>
                            </div>
                            <div class="col-md-3 col-lg-3 col-xl-3 course-card mobile-hide">
                              <div class="modern-card loading-box">
                                Data loading...
                                <facebook-loader></facebook-loader>
                              </div>
                            </div>
                            <div class="col-md-3 col-lg-3 col-xl-3 course-card mobile-hide">
                              <div class="modern-card loading-box">
                                Data loading...
                                <facebook-loader></facebook-loader>
                              </div>
                            </div>
                          </div>
                          <div v-if="examsData.length > 0" class="row">
                            <div v-for="(exam, index) in examsData" :key="index" class="col-md-4 col-lg-3 col-xl-3 course-card">
                              <div class="course-card" v-if="!((exam.exam_status == 'started') && (exam.exam_duration_type == 0))">
                                <div class="modern-card">
                                  <div class="modern-head">
                                    <div class="st offline">{{(exam.exam_availablitiy == 0)? 'Offline': 'Online'}}</div>
                                    <h2>{{(exam.course)? exam.course.name: ''}}</h2>
                                  </div>
                                  <div class="modern-stat">
                                    <div class="time-md">{{exam.exam_name}}</div>
                                  </div>
                                  <div class="modern-stat sub-item">
                                    <ul>
                                      <li>Exam Date: {{exam.start_date.split(' ')[0]}}</li>
                                      <li>Duration: {{exam.duration}} Minutes </li>
                                    </ul>
                                  </div>
                                  <div class="start-time">Start Time: {{exam.start_date.split(' ')[1]}}</div>
                                  <div class="time-area">
                                    <div class="subs start">
                                      MCQ: <span>{{exam.mcqCounts}}</span>
                                    </div>
                                    <div class="subs end">
                                      Easay: <span>{{exam.essayCounts}}</span>
                                    </div>
                                  </div>

                                  <h3 v-if="exam.is_payable">{{currency.code}} {{ numberWithCommas(exam.exam_cost)}}</h3>
                                  <h3 v-else class="free">Free</h3>

                                  <div class="modern-body">
                                    <button v-if="exam.is_payable" @click="setPaymentModal(exam.id, exam.exam_cost)" type="button" data-toggle="modal" data-target="#payment-modal" class="btn btn-primary btn-info" :disabled="(exam.isRegistered || ((exam.exam_status != 'completed') && (exam.exam_duration_type == 0)))">
                                      {{(exam.isRegistered)? 'Registered': 'Pay & Register'}}
                                    </button>
                                    <button v-else type="button" @click="setRegisterModal(exam.id, exam.exam_cost)" data-toggle="modal" data-target="#free-register-exam-modal" class="btn btn-primary btn-info free" :disabled="(exam.isRegistered || ((exam.exam_status != 'completed') && (exam.exam_duration_type == 0)))">
                                      {{(exam.isRegistered)? 'Registered': 'Register'}}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" v-if="no_data && examsData.length <= 0">
                            <div class="col-md-12">
                              <div class="empty-data">
                                <img src="/media/icons/empty.png" />
                                <h2>No Records Available</h2>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="tab-pane" id="m_tabs_6_3" role="tabpanel">
                          <div class="card-body payment mobile-m-t-20">
                            <div class="row">
                              <div class="col-md-12">
                                <div class="pay-table">
                                  <table class="table table-sm table-hover table-light">
                                    <thead>
                                      <tr>
                                        <th scope="col">Date</th>
                                        <th scope="col">Exam Name</th>
                                        <th scope="col">Amount</th>
                                        <th scope="col">Ref</th>
                                      </tr>
                                    </thead>
                                    <tbody v-if="studentPaymentData.length > 0" id="payment_history_body">
                                      <tr v-for="(payment, index) in studentPaymentData" :key="index">
                                        <td scope="col">{{payment.pay_date}}</td>
                                        <td scope="col">{{payment.exam_name}}</td>
                                        <td scope="col">{{currency.symbol}} {{numberWithCommas(payment.amount)}}</td>
                                        <td scope="col"><a :href="examDocumentURL + payment.payslip" target="_blank">{{payment.payslip}}</a></td>
                                      </tr>
                                    </tbody>
                                    <tbody v-else>
                                      <tr>
                                        <td colspan="4" scope="col">
                                          <div class="empty-data">
                                            <img src="/media/icons/empty.png" />
                                            <h2>No Exam Payments Available</h2>
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- start Exam Modal -->
    <div class="modal fade exam-page-modal" id="start-exam-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">{{studentExamNameForModal}}</h5>
            <img class="close" src="/media/icons/close.png" data-dismiss="modal" aria-label="Close" width="53px" />
          </div>
          <div class="modal-body">
            <div class="alert alert-danger" id="exam_start_error" style="display:none" ></div>
            <p>Do you want to start Exam Now?</p>
            <div v-if="examFaceCapture" class="alert alert-warning classroom_empty_msg no-margin-b custom-msg">
              Your face will be captured during this exam!
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" @click="openExamPage('start')">Start Now</button>
          </div>
        </div>
      </div>
    </div>

    <!-- continue Exam Modal -->
    <div class="modal fade exam-page-modal" v-if="showModal" id="continue-exam-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">{{studentExamNameForModal}}</h5>
            <img class="close" src="/media/icons/close.png" data-dismiss="modal" aria-label="Close" width="53px" />
          </div>
          <div class="modal-body">
            <div class="alert alert-danger" id="exam_continue_error" style="display:none" ></div>
            <p>Do you want to continue Exam again?</p>
            <div v-if="examFaceCapture" class="alert alert-warning classroom_empty_msg no-margin-b custom-msg">
              Your face will be captured during this exam!
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary continue" @click="openExamPage('continue')">Continue Now</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Completed Offline Exam Modal -->
    <div class="modal fade exam-page-modal" id="complete-offline-exam-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">{{studentExamNameForModal}}</h5>
            <img class="close" src="/media/icons/close.png" data-dismiss="modal" aria-label="Close" width="53px" />
          </div>
          <div class="modal-body">
            <p>Do you want to complete offline exam?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary continue" @click="setOfflineExamCompleted()">Mark as Completed</button>
          </div>
        </div>
      </div>
    </div>

    <!-- free-regster Exam Modal -->
    <div class="modal fade exam-page-modal" id="free-register-exam-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <input type="hidden" name="selectedFreeExamId" id="selectedFreeExamId">
            <h5 class="modal-title" id="exampleModalLabel">Register Now</h5>
            <img class="close" src="/media/icons/close.png" data-dismiss="modal" aria-label="Close" width="53px" />
          </div>
          <div class="modal-body">
            <div class="alert alert-success" id="examReg_success" style="display:none" >You have successfully registered to the exam.</div>
            <p>Are you sure want to register for this Exam?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" @click="registerExamFree()">Yes Register Now</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Payment modal -->
    <div class="modal fade" id="payment-modal" tabindex="-1" role="dialog" aria-labelledby="payment-modal-title" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <input type="hidden" name="selectedExamId" id="selectedExamId">
            <input type="hidden" name="examCost" id="examCost">
            <h5 class="modal-title" id="payment-modal-title">
              Exam Payment
            </h5>
            <img class="close" src="/media/icons/close.png" data-dismiss="modal" aria-label="Close" width="53px" />
          </div>
          <div class="modal-body">
            <div class="alert alert-success" id="submit_payment_success" style="display:none" >
              Please wait while we process your request....
            </div>
            <div class="alert alert-danger" id="submit_payment_error" style="display:none" >Please upload payslip.!</div>
            <div class="payment-types-block">
              <ul class="nav nav-tabs m-tabs-line m-tabs-line--primary m-tabs-line--2x" role="tablist">
                <li class="nav-item m-tabs__item">
                  <a @click="paymentType = 'online'" class="nav-link m-tabs__link" data-toggle="tab" href="#online_payment_tab" role="tab" aria-selected="true">
                    Online
                  </a>
                </li>
                <li class="nav-item m-tabs__item">
                  <a @click="paymentType = 'payslip'" class="nav-link m-tabs__link active show" data-toggle="tab" href="#payslip_upload_tab" role="tab" aria-selected="false">
                    Upload Payslip
                  </a>
                </li>
              </ul>
            </div>
            <div class="payment-form-block">
              <div class="tab-content">
                <div class="tab-pane" id="online_payment_tab" role="tabpanel">
                  <form id="online-payment-data">
                    <div class="form-group">
                      <label>Payment Amount ({{currency.code}})</label>
                      <input type="number" class="form-control" id="exam_cost" name="exam_cost" disabled/>
                    </div>
                    <br />
                    <div class="form-group">
                      <a href="/doc/Terms and Conditions.pdf" download>Read terms and Conditions</a>
                    </div>
                    <div class="form-group form-check">
                      <input type="checkbox" v-model="agreementChecked" class="form-check-input" id="terms_check" />
                      <label class="form-check-label pay-check" for="exampleCheck1">I have read and agreed with the terms and conditions</label>
                    </div>
                  </form>
                </div>
                <div class="tab-pane active show" id="payslip_upload_tab" role="tabpanel">
                  <form id="payslip-payment-data">
                    <div class="form-group">
                      <label>Payment Amount ({{currency.code}})</label>
                      <input type="number" class="form-control" id="exam_cost" name="exam_cost" :value="examFeeToPay" disabled/>
                    </div>
                    <br />
                    <div class="form-group">
                      <input @change="handleFileUpload()" type="file" name="payslip_upload" ref="file" id="payslip_upload" class="form-control">
                    </div>
                  </form>
                  <div class="file-message">
                    Max file size <span>2MB</span> Supported file formats:
                    <span>JPEG/PNG/PDF</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button v-if="(paymentType == 'online')" class="btn btn-primary" :disabled="!agreementChecked" @click="payExamFeeAndRegister()">Proceed to pay</button>
            <button v-else class="btn btn-primary" @click="uploadPayslip()">Upload Payslip</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { FacebookLoader } from 'vue-content-loader'
var $ = require('jquery')
var Config = require('../router/Config')
var Cookies = require('vue-cookies')
var userPermissions = Cookies.get('userPermissions')

var examDashboard = {
  name: 'examDashboard',
  components: { FacebookLoader },
  props: [],
  data () {
    return {
      no_data: true,
      loaderlist: true,
      examDocumentURL: Config.EXAM_DOCUMENTS + Cookies.get('clientId') + '/',
      examsData: [],
      studentOnlinePendingApprovalExam: [],
      studentOnlineScheduledExam: [],
      studentOnlineCompletedExam: [],
      studentOnlineNotAttendedExam: [],
      studentOfflinePendingExam: [],
      studentOfflineCompletedExam: [],
      examsList: [],
      studentExamData: [],
      studentPaymentData: [],
      showModal:true,
      courseList: [],
      subjectList: [],
      currency: [],
      clientId: Cookies.get('clientId'),
      agreementChecked: false,
      studentExamNameForModal: '',
      studentExamIdForModal: '',
      paymentType: 'payslip',
      payslipFile: '',
      examFeeToPay: 0,
      nextExamDuration: 0,
      examFaceCapture: false
    }
  },
  beforeCreate: function () {
    if (!userPermissions.course_view) {
      this.$router.push('/')
    }
  },
  beforeMount: function () {
    if (userPermissions.exam_video_face_capture) {
      this.examFaceCapture = true
    }
  },
  mounted () {
    this.getexamDashboard()
  },
  updated () {
  },
  methods: {
    getexamDashboard: function () {
      this.loaderlist = true
      this.no_data = true
      this.axios.get(Config.API_URL + '/api/fe/exam/exam-dashboard' + '?token=' + Cookies.get('accessToken') + '&studentId=' + Cookies.get('studentId')).then(response => {
        this.examsData = response.data.examsData
        this.studentExamData = response.data.studentExamData
        this.studentOnlinePendingApprovalExam = response.data.studentOnlinePendingApprovalExam
        this.studentOnlineScheduledExam = response.data.studentOnlineScheduledExam
        this.studentOnlineCompletedExam = response.data.studentOnlineCompletedExam
        this.studentOnlineNotAttendedExam = response.data.studentOnlineNotAttendedExam
        this.studentOfflinePendingExam = response.data.studentOfflinePendingExam
        this.studentOfflineCompletedExam = response.data.studentOfflineCompletedExam
        this.courseList = response.data.courseList
        this.subjectList = response.data.subjectList
        this.examsList = response.data.examsList
        this.studentPaymentData = response.data.studentPayments
        this.currency = response.data.currency
        Cookies.set('currency', this.currency)

        if (this.examsList.length <= 0) {
          console.log('test' + this.examsList.length)
          this.no_data = true
        }
        this.loaderlist = false
        if (response.data.nextExamScheduled) {
          var nextExamData = response.data.nextExamScheduled
          this.getNextExamDuration(nextExamData.exam_master.start_date)
        }
      }).catch(function (error) {
        console.log(error)
      })
    },
    getNextExamDuration (nextExamStartDate) {
      var nextExamTimestamp = Date.parse(nextExamStartDate)
      var dateNow = Date.now()
      this.nextExamDuration = (nextExamTimestamp - dateNow)
    },
    handleFileUpload () {
      this.payslipFile = this.$refs.file.files[0]
    },
    setPaymentModal: function (examId, examCost) {
      $('#selectedExamId').val(examId)
      $('#examCost').val(examCost)
      $('#exam_cost').val(examCost)
      this.examFeeToPay = examCost
    },
    payExamFeeAndRegister: function () {
      var selectedExamId = $('#selectedExamId').val()
      var random = Math.floor(1000 + Math.random() * 9000)
      var orderid = selectedExamId + 'T' + random
      // var enteredAmount = $('#examCost').val()

      Cookies.set('installment_id', orderid)
      Cookies.set('exam_id', selectedExamId)
      Cookies.set('payment_purpose', 'exam') // the reason for the payment

      // need to handle with payment gateway related to the client.
    },
    setRegisterModal: function (examId) {
      $('#selectedFreeExamId').val(examId)
    },
    registerExamFree: function () {
      var examId = $('#selectedFreeExamId').val()
      this.axios.get(Config.API_URL + '/api/fe/exam/register-exam' + '?token=' + Cookies.get('accessToken') + '&examId=' + examId + '&studentId=' + Cookies.get('studentId')).then(response => {
        var result = response.data
        console.log(result)
        $('#examReg_success').fadeTo(5000, 500).slideUp(500, function () {
          // $('#free-register-exam-modal').modal('hide')
          location.reload()
        })
      }).catch(function (error) {
        console.log(error)
      })
    },
    getFilterOptionData: function (optionType) {
      var courseId = $('#courses').val()
      var subjectId = $('#subjects').val()

      this.axios.get(Config.API_URL + '/api/fe/exam/get-filter-option-data' + '?token=' + Cookies.get('accessToken') +
          '&courseId=' + courseId +
          '&subjectId=' + subjectId +
          '&optionType=' + optionType +
          '&clientId=' + this.clientId)
        .then(response => {
          var result = response.data
          console.log('get-filter-option-data')
          console.log(result)
          if (optionType === 'courses') {
            this.subjectList = response.data.subjectList
            this.examsList = response.data.examsList
          } else if (optionType === 'subjects') {
            this.examsList = response.data.examsList
          }
        }).catch(function (error) {
          console.log(error)
        })
    },
    searchExam: function () {
      var courseId = $('#courses').val()
      var subjectId = $('#subjects').val()
      var examId = $('#exams').val()
      var academicYear = $('#academic_year').val()

      this.axios.get(Config.API_URL + '/api/fe/exam/search-exam' + '?token=' + Cookies.get('accessToken') +
          '&courseId=' + courseId +
          '&subjectId=' + subjectId +
          '&examId=' + examId +
          '&academicYear=' + academicYear +
          '&studentId=' + Cookies.get('studentId') +
          '&clientId=' + this.clientId)
        .then(response => {
          var result = response.data
          console.log('searchExam')
          console.log(result)
          this.examsData = response.data.examsData
          if (self.examsData.length <= 0) {
            self.no_data = false;
            self.loaderlist = false;
          }
          self.no_data = false;
          self.loaderlist = false;
        }).catch(function (error) {
          console.log(error)
        })
    },
    setExamData: function (examId, examName) {
      this.studentExamIdForModal = examId
      this.studentExamNameForModal = examName
    },
    openCompleteOfflineExamModal: function (examId, examName) {
      this.studentExamIdForModal = examId
      this.studentExamNameForModal = examName
    },
    openExamPage: function (startType) {
      Cookies.set('studentExamIdToStart', this.studentExamIdForModal)

      this.axios.post(Config.API_URL + '/api/fe/exam/start-exam' + '?token=' + Cookies.get('accessToken'), {
        studentExamIdToStart: this.studentExamIdForModal,
        userId: Cookies.get('userId')
      }).then(response => {
        var result = response.data
        console.log('searchExam')
        console.log(result)
        if (result.res == 1) {
          const routeData = this.$router.resolve({ name: 'startexam' })
          console.log(routeData)
          Cookies.set('startExam', true)
          Cookies.set('examContinue', true)
          window.open(routeData.href, '_blank')
          this.showModal = false
          this.$forceUpdate()
        //   location.reload()
        } else {
          if (startType === 'start') {
            $('#exam_start_error').empty().html(result.msg)
            $('#exam_start_error').fadeTo(5000, 500).slideUp(500, function () {
              location.reload()
            })
          } else {
            $('#exam_continue_error').empty().html(result.msg)
            $('#exam_continue_error').fadeTo(5000, 500).slideUp(500, function () {
              location.reload()
            })
          }
        }

      }).catch(function (error) {
        console.log(error)
      })
    },
    reviewExam: function (examId) {
      Cookies.set('studentExamIdToStart', examId)
      const routeData = this.$router.resolve({ name: 'startexam' })
      Cookies.set('startExam', false)
      Cookies.set('examContinue', false)
      window.open(routeData.href, '_blank')
    },
    setOfflineExamCompleted: function () {
      this.axios.post(Config.API_URL + '/api/fe/exam/completed-offline-exam' + '?token=' + Cookies.get('accessToken'), {
        examId: this.studentExamIdForModal,
        userId: Cookies.get('userId')
      }).then(response => {
        var result = response.data
        if (result.res == 1) {
          location.reload()
        }

      }).catch(function (error) {
        console.log(error)
      })
    },
    uploadPayslip: function () {
      var validFile = false
      var uploadedFile = $('#payslip_upload').val()
      var selectedExamId = $('#selectedExamId').val()

      var ext = uploadedFile.split('.').pop().toLowerCase()
      if ($.inArray(ext, ['png', 'jpg', 'jpeg', 'pdf']) == -1) {
        $('#submit_payment_error').empty().html('Invalid Image Format! Image Format Must Be JPG, JPEG, PNG or PDF.')
        $('#submit_payment_error').fadeTo(5000, 500).slideUp(500)
      } else {
        var payslipSize = $('#payslip_upload')[0].files[0].size
        if (payslipSize > 2000 && payslipSize < 2097152) {
          validFile = true
        } else {
          $('#submit_payment_error').empty().html('Maximum upload filesize is 2MB.')
          $('#submit_payment_error').fadeTo(5000, 500).slideUp(500)
        }
      }

      if (validFile) {
        const formData = new FormData();
        formData.append('file', this.payslipFile);

        this.axios.post(Config.API_URL + '/api/fe/exam/upload-payslip' + '?token=' + Cookies.get('accessToken') +
          '&examId=' + selectedExamId +
          '&examFee=' + this.examFeeToPay +
          '&studentId=' + Cookies.get('studentId'),
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(response => {
          var result = response.data
          if (result.res == 1) {
            $('#submit_payment_success').empty().html('Payslip uploaded successfully.!')
            $('#submit_payment_success').fadeTo(5000, 500).slideUp(500)
            setTimeout(function () {
              location.reload()
            }, 2000)
          }

        }).catch(function (error) {
          console.log(error)
        })
      }
    }
  }
}
export default examDashboard
</script>

<style scoped lang="scss">
    @import "../assets/scss/component/exam/exam";

    @media (max-width:767px) {
     .mobile-m-t-20 {
        margin-top: 20px !important;
    }
}


</style>
